// Properties of a card as in Notion (stage Q, um/2026-10-30/02, R-U6): two or three are seen, the rest open under a small
// «Показать ещё N». The section's eye (field settings) chooses the seen ones; the open state is the person's, kept in this browser.

import { useMemo, useState } from 'react';
import { cardSplit, type FieldDef, type RecordObj } from '@confdeck/core-shared';
import { useMeta, useSync } from '../sync/react.tsx';
import { Chevron } from '../ui/primitives.tsx';
import { LabelEdge, Prop } from './Prop.tsx';
import s from './record.module.css';

const KEY = 'confdeck:props-open';
const readOpen = (): Record<string, boolean> => { try { return JSON.parse(localStorage.getItem(KEY) ?? '{}') as Record<string, boolean>; } catch { return {}; } };
const writeOpen = (k: string, v: boolean) => { try { const m = readOpen(); if (v) m[k] = true; else delete m[k]; localStorage.setItem(KEY, JSON.stringify(m)); } catch { /* a convenience of this browser */ } };

export function Properties({ rec, fields }: { rec: RecordObj; fields: FieldDef[] }) {
  const client = useSync();
  const meta = useMeta();
  // Opened for a section, not for one record: who wants every field of a deal wants them in the next deal too.
  const key = `${location.host}:${client.header?.userId ?? ''}:${rec.typeId}`;
  // The key changes when the session's person arrives after a card drawn from the local cache: the state is read again for it.
  const [state, setState] = useState(() => ({ key, open: !!readOpen()[key] }));
  const open = state.key === key ? state.open : !!readOpen()[key];
  const setOpen = (v: boolean) => setState({ key, open: v });
  // The split is made when the card opens and when the section changes its eyes, not on each edit: a field just cleared or
  // filled stays where the person is looking.
  const sig = fields.map((f) => `${f.id}:${f.card ?? ''}`).join(',');
  const prefer = meta.views(rec.typeId).find((v) => v.shared && v.layout === 'table')?.columns.filter((c) => !c.hidden).map((c) => c.field) ?? [];
  const { main, more } = useMemo(() => cardSplit(fields, rec.data, prefer), [rec.id, sig, prefer.join(',')]);
  const toggle = () => { setOpen(!open); writeOpen(key, !open); };
  return (
    <>
      {main.length + (open ? more.length : 0) > 0 && (
        <dl className={s.props}>
          {main.map((f) => <Prop key={f.id} rec={rec} field={f} />)}
          {open && more.map((f) => <Prop key={f.id} rec={rec} field={f} />)}
          <LabelEdge />
        </dl>
      )}
      {more.length > 0 && (
        <button type="button" className={s.moreProps} aria-expanded={open} onClick={toggle}>
          <Chevron open={open} size={12} />{open ? 'Скрыть' : `Показать ещё ${more.length}`}
        </button>
      )}
    </>
  );
}
